module.exports = __webpack_public_path__ + "img/buy_normal_th.79fc1b77.png";